export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "25", value: 25 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {},
  sortOrder: "asc", // asc||desc
  sortField: "grade",
  pageNumber: 1,
  pageSize: 10
};